import ShopPageGrid from "./shop-page-grid";

export default ShopPageGrid;